// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"478":"bc600af5","498":"adbe6a95","703":"56f7000b","787":"05dc9179"}[chunkId] + ".chunk.js";
};